import Button from '@components/Button';
import useProject from '@hooks/useProject';
import { ShopOrderStatus, ShopStatus } from '@models/shop/common';
import { useFlow } from '@stackflow/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    shopId: string;
    status: ShopOrderStatus;
    shopStatus: ShopStatus;
}

function OrderButton({ shopId, status, shopStatus }:Props) {
    const { push, pop } = useFlow();
    const { t } = useTranslation('shopDetail');
    const disabled = status !== 'OPEN';
    const project = useProject();
    const message = useMemo(() => {
        console.log({ shopStatus });
        if (project?.features.orderEnabled) {
            if (shopStatus === 'NOT_USE_APP_ORDER') {
                return t('button.viewMenu');
            }
            return disabled ? t('button.preparing') : t('button.goToOrder');
        }
        return t('button.viewMenu');
    }, [disabled, project, shopStatus, t]);
    return (
        <div className={styles.order}>
            <Button fullWidth
                disabled={disabled}
                onClick={() => {
                    pop();
                    push('ItemsActivity', { shopId, type: 'ALL' });
                }}>
                {message}
            </Button>
        </div>
    );
}

export default OrderButton;
